import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { DateRange } from '@core/services/data.service';
import { DatePipe } from '@angular/common';
import { ModalService } from '@common/services/modal.service';

@Component({
  selector: 'date-range-selector',
  templateUrl: './date-range-selector.component.html',
  styleUrls: ['./date-range-selector.component.scss']
})
export class DateRangeSelectorComponent implements OnInit {

  @Input()
  public value: DateRange = null;

  public selecting = {
    from: false,
    to: false
  }

  @Output()
  public selected: EventEmitter<{ name: string, range: DateRange }> = new EventEmitter<{ name: string, range: DateRange }>();

  constructor(private date: DatePipe, private modal: ModalService) { }

  ngOnInit(): void {
  }

  public select(type: 'from' | 'to', date: Date) {

    this.selecting[type] = !this.selecting[type];

    switch (type) {
      case 'from':

        this.value = {
          from: date,
          to: this.value && this.value.to.getTime() >= date.getTime() ? this.value.to : date
        }

        break;

      case 'to':

        this.value = {
          to: date,
          from: this.value && this.value.from.getTime() <= date.getTime() ? this.value.from : date
        }

        break;
    }    
  }

  public emit() {
    this.selected.emit({ name: this.date.transform(this.value.from, 'dd/MM/yyyy') + ' - ' + this.date.transform(this.value.to, 'dd/MM/yyyy'), range: this.value });
    this.modal.of(this).hide();
  }

}
